<template>
  <ion-list>
    <ion-item
      v-for="n in 10"
      :key="n"
      detail="false"
      class="ion-text-wrap"
    >
      <div class="shimmer-item-container">
        <div class="shimmer-box title-line-shimmer"></div>
        <div class="shimmer-box subtitle-line-shimmer"></div>
      </div>
    </ion-item>
  </ion-list>
</template>

<script>
export default {
  name: 'AnnotationsShimmer'
};
</script>

<style scoped>
.shimmer-box {
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  border-radius: 4px;
}

@keyframes shimmer {
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}

.shimmer-item-container {
  width: 100%;
  padding: 12px 0;
}

.title-line-shimmer {
  width: 180px;
  height: 30px;
  margin-bottom: 8px;
}

.subtitle-line-shimmer {
  width: 100%;
  height: 30px;
}
</style>
